<template>
  <div>
    <Top class="top"/>
    <div class="l-container">
      <div class="inner">
        <div class="col_menu">
          <div class="col_menu_head">
            <h3 class="col_menu_text">集团动态</h3>
          </div>
          <div class="col_menu_con">
            <div class="col_list">
              <ul class="wp_listcolumn">
                <li :class="isActive===0?'select':''" @click="news()">
                  <a><span class="column-name">集团要闻</span></a>
                </li>
                <li :class="isActive===1?'select':''" @click="notice()">
                  <a><span class="column-name">集团公告</span></a>
                </li>
                <li :class="isActive===2?'select':''" @click="active()">
                  <a><span class="column-name">专题活动</span></a>
                </li>
                <li :class="isActive===3?'select':''" @click="safety()">
                  <a><span class="column-name">安全生产</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col_news">
          <!-- 集团要闻 -->
          <div class="col_news_box" v-if="isActive===0">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜集团动态 | 集团要闻</span></span>
                </li>
                <li class="col_title">
                  <h2>集团要闻</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con" @scroll="handleScroll('news')" ref="newsContainer">
              <div class="contain">
                <ul>
                  <li v-for="(item,index) in displayedListWord" :key="index">
                    <router-link :to="{path:'/bidsNew', query:{id:item.id,title:'集团要闻'}}">
                      <a href="/" target="_blank">{{item.articleTitle}}</a>
                    </router-link>
                    <span>{{item.releaseDate}}</span>
                  </li>
                </ul>
                <!-- 加载更多按钮和加载状态 -->
                <!-- 在data中添加总数量字段 -->
             
                <!-- 在模板中修改条件 -->
                <div class="load-more-container" v-if="listWord.length < totalCounts.news || loadingStates.news">
                  <div v-if="loadingStates.news" class="loading-indicator">
                    <div class="loading-spinner"></div>
                    <span>加载中...</span>
                  </div>
                  <button v-else @click="loadMoreNews" class="load-more-btn">加载更多</button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 集团公告 -->
          <div class="col_news_box" v-else-if="isActive===1">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜集团动态 | 集团公告</span></span>
                </li>
                <li class="col_title">
                  <h2>集团公告</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con" @scroll="handleScroll('notice')" ref="noticeContainer">
              <div class="col_news_list listcon">
                <ul>
                  <li v-for="(item,index) in displayedContactL" :key="index">
                    <router-link :to="{path:'/bidsNew', query:{id:item.id,title:'通知公告'}}">
                      <a href="/" target="_blank">{{item.articleTitle}}</a>
                    </router-link>
                    <span>{{item.releaseDate}}</span>
                  </li>
                </ul>
                <!-- 加载更多按钮和加载状态 -->
                <div class="load-more-container" v-if="contactL.length > displayedContactL.length || loadingStates.notice">
                  <div v-if="loadingStates.notice" class="loading-indicator">
                    <div class="loading-spinner"></div>
                    <span>加载中...</span>
                  </div>
                  <button v-else @click="loadMoreNotice" class="load-more-btn">加载更多</button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 专题活动 -->
          <div class="col_news_box" v-else-if="isActive===2">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜集团动态 | 专题活动</span></span>
                </li>
                <li class="col_title">
                  <h2>专题活动</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con">
              <div style="font-size: 16px">信息采集中......</div>
            </div>
          </div>
          
          <!-- 安全生产 -->
          <div class="col_news_box" v-else-if="isActive===3">
            <div class="col_news_head">
              <ul class="col_metas">
                <li class="col_path">
                  <span>当前位置：<span style="color: #2F2F2F;">首页｜集团动态 | 安全生产</span></span>
                </li>
                <li class="col_title">
                  <h2>安全生产</h2>
                </li>
              </ul>
            </div>
            <div class="col_news_con" @scroll="handleScroll('safety')" ref="safetyContainer">
              <div class="col_news_list listcon">
                <ul>
                  <li v-for="(item,index) in displayedSafetyL" :key="index">
                    <router-link :to="{path:'/bidsNew', query:{id:item.id,title:'安全生产'}}">
                      <a href="/" target="_blank">{{item.articleTitle}}</a>
                    </router-link>
                    <span>{{item.releaseDate}}</span>
                  </li>
                </ul>
                <!-- 加载更多按钮和加载状态 -->
                <div class="load-more-container" v-if="safetyL.length > displayedSafetyL.length || loadingStates.safety">
                  <div v-if="loadingStates.safety" class="loading-indicator">
                    <div class="loading-spinner"></div>
                    <span>加载中...</span>
                  </div>
                  <button v-else @click="loadMoreSafety" class="load-more-btn">加载更多</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterHtm style="margin-top: 10px"/>
  </div>
</template>

<script>
import $http  from '../ApI/request'  //$http是在导入时自定义的命名可变的
import Top from './Top'
import FooterHtm from './FooterHtm'
export default {
  name: 'State',
  components:{
    Top,
    FooterHtm
  },
  data () {
    let jd = localStorage.getItem('stjd');
    if (jd) {
      if (this.$route.params.num) {
        localStorage.setItem('stjd', this.$route.params.num);
      }
    } else {
      localStorage.setItem('stjd',this.$route.params.num)
    }
    return {
      // 原始数据数组
      listWord:[],
      contactL:[],
      partyList:[],
      activList:[],
      safetyL:[],
      
      // 显示的数据数组（用于懒加载）
      displayedListWord: [],
      displayedContactL: [],
      displayedSafetyL: [],
      
      // 分页参数
      pageSize: 10, // 每次加载的数量
      currentPages: {
        news: 1,
        notice: 1,
        safety: 1
      },
      
      // 加载状态
      loadingStates: {
        news: false,
        notice: false,
        safety: false
      },
      
      // 添加总数量统计
    totalCounts: {
      news: 0,
      notice: 0,
      safety: 0
    },
    
    num:localStorage.getItem('stjd'),
    id:'',
    isActive:0,
      
      // 添加加载状态标记
      loadedTabs: {
        news: false,
        notice: false,
        active: false,
        safety: false
      }
    }
  },
  mounted() {
    // 立即加载第一个tab的数据，并添加调试信息
    console.log('State组件已挂载，开始加载数据');
    this.loadNewsData();
    
    // 根据路由参数设置活跃tab
    if (this.$route.params.num) {
      const num = parseInt(this.$route.params.num);
      if (num >= 0 && num <= 3) {
        this.isActive = num;
        switch(num) {
          case 0:
            this.loadNewsData();
            break;
          case 1:
            this.loadNoticeData();
            break;
          case 2:
            this.loadActiveData();
            break;
          case 3:
            this.loadSafetyData();
            break;
        }
      }
    }
  },
  methods: {
    // 修改加载集团要闻数据方法
    loadNewsData() {
      console.log('开始加载集团要闻数据');
      
      if (this.loadedTabs.news) {
        console.log('数据已缓存，直接更新显示');
        this.updateDisplayedNews();
        return;
      }
      
      this.loadingStates.news = true;
      $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
        params:{
          articleType:'集团要闻',
          column: 'releaseDate',
          order: 'desc',
          pageSize:'10',
          // pageNo:'1'
        }
      }).then(res=>{
        console.log('集团要闻数据加载成功:', res.data);
        
        // 检查数据结构
        // 在 loadNewsData 方法的成功回调中添加
        if (res.data && res.data.result && res.data.result.records) {
          this.listWord = res.data.result.records;
          this.totalCounts.news = res.data.result.total || 0; // 添加这行
          this.loadedTabs.news = true;
          this.currentPages.news = 1;
          this.updateDisplayedNews();
          console.log('显示的数据:', this.displayedListWord);
        }
        else {
          console.error('数据结构不正确:', res.data);
          this.listWord = [];
          this.displayedListWord = [];
        }
        
        this.loadingStates.news = false;
      }).catch(e=>{
        console.error('加载集团要闻失败:', e);
        this.loadingStates.news = false;
        this.listWord = [];
        this.displayedListWord = [];
        
        // 显示错误信息给用户
        this.$message && this.$message.error('数据加载失败，请稍后重试');
      });
    },
    
    // 修改更新显示的新闻数据方法
    updateDisplayedNews() {
      const endIndex = this.currentPages.news * this.pageSize;
      this.displayedListWord = this.listWord.slice(0, endIndex);
      console.log('更新显示数据，当前页:', this.currentPages.news, '显示条数:', this.displayedListWord.length);
    },
    
    // 修改加载集团公告数据方法
    loadNoticeData() {
      console.log('开始加载集团公告数据');
      
      if (this.loadedTabs.notice) {
        this.updateDisplayedNotice();
        return;
      }
      
      this.loadingStates.notice = true;
      $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
        params:{
          articleType:'通知公告',
          column: 'releaseDate',
          order: 'desc',
          pageSize: '10',
          pageNo: '1'
        }
      }).then(res=>{
        console.log('集团公告数据加载成功:', res.data);
        
        if (res.data && res.data.result) {
          this.contactL = res.data.result.records || [];
          this.totalCounts.notice = res.data.result.total || 0; // 添加这行
          this.loadedTabs.notice = true;
          this.currentPages.notice = 1;
          this.updateDisplayedNotice();
        } else {
          this.contactL = [];
          this.displayedContactL = [];
        }
        
        this.loadingStates.notice = false;
      }).catch(e=>{
        console.error('加载集团公告失败:', e);
        this.loadingStates.notice = false;
        this.contactL = [];
        this.displayedContactL = [];
      });
    },
    
    // 加载安全生产数据
    loadSafetyData() {
      console.log('开始加载安全生产数据');
      
      if (this.loadedTabs.safety) {
        this.updateDisplayedSafety();
        return;
      }
      
      this.loadingStates.safety = true;
      $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list',{
        params:{
          articleType:'安全生产',
          column: 'releaseDate',
          order: 'desc',
          pageSize: '10',
          pageNo: '1'
        }
      }).then(res=>{
        console.log('安全生产数据加载成功:', res.data);
        
        if (res.data && res.data.result) {
          this.safetyL = res.data.result.records || [];
          this.totalCounts.safety = res.data.result.total || 0; // 添加这行
          this.loadedTabs.safety = true;
          this.currentPages.safety = 1;
          this.updateDisplayedSafety();
        } else {
          this.safetyL = [];
          this.displayedSafetyL = [];
        }
        
        this.loadingStates.safety = false;
      }).catch(e=>{
        console.error('加载安全生产失败:', e);
        this.loadingStates.safety = false;
        this.safetyL = [];
        this.displayedSafetyL = [];
      });
    },
    
    // 加载更多集团要闻
    loadMoreNews() {
      if (this.loadingStates.news) return;
      
      this.loadingStates.news = true;
      const nextPage = Math.floor(this.listWord.length / 10) + 1;
      
      $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list', {
        params: {
          articleType: '集团要闻',
          column: 'releaseDate',
          order: 'desc',
          pageSize: '10',
          pageNo: nextPage.toString()
        }
      }).then(res => {
        if (res.data && res.data.result && res.data.result.records) {
          // 将新数据追加到现有数据
          this.listWord = [...this.listWord, ...res.data.result.records];
          this.currentPages.news++;
          this.updateDisplayedNews();
        }
        this.loadingStates.news = false;
      }).catch(e => {
        console.error('加载更多集团要闻失败:', e);
        this.loadingStates.news = false;
      });
    },
    
    // 更新显示的集团公告数据
    updateDisplayedNotice() {
      const endIndex = this.currentPages.notice * this.pageSize;
      this.displayedContactL = this.contactL.slice(0, endIndex);
    },
    
    // 加载更多集团公告
    loadMoreNotice() {
      if (this.loadingStates.notice) return;
      
      this.loadingStates.notice = true;
      const nextPage = Math.floor(this.contactL.length / 10) + 1;
      
      $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list', {
        params: {
          articleType: '通知公告',
          column: 'releaseDate',
          order: 'desc',
          pageSize: '10',
          pageNo: nextPage.toString()
        }
      }).then(res => {
        if (res.data && res.data.result && res.data.result.records) {
          this.contactL = [...this.contactL, ...res.data.result.records];
          this.currentPages.notice++;
          this.updateDisplayedNotice();
        }
        this.loadingStates.notice = false;
      }).catch(e => {
        console.error('加载更多集团公告失败:', e);
        this.loadingStates.notice = false;
      });
    },
    
    // 加载更多安全生产数据
    loadMoreSafety() {
      if (this.loadingStates.safety) return;
      
      this.loadingStates.safety = true;
      const nextPage = Math.floor(this.safetyL.length / 10) + 1;
      
      $http.get('/ri-richuang/announcement/wdOaPressAnnouncement/list', {
        params: {
          articleType: '安全生产',
          column: 'releaseDate',
          order: 'desc',
          pageSize: '10',
          pageNo: nextPage.toString()
        }
      }).then(res => {
        if (res.data && res.data.result && res.data.result.records) {
          this.safetyL = [...this.safetyL, ...res.data.result.records];
          this.currentPages.safety++;
          this.updateDisplayedSafety();
        }
        this.loadingStates.safety = false;
      }).catch(e => {
        console.error('加载更多安全生产失败:', e);
        this.loadingStates.safety = false;
      });
    },
    
    // 加载专题活动数据
    loadActiveData() {
      console.log('加载专题活动数据');
      // 这里可以添加专题活动的数据加载逻辑
      // 目前显示"信息采集中......"
      this.loadedTabs.active = true;
    },
    
    // 更新显示的安全生产数据
    updateDisplayedSafety() {
      const endIndex = this.currentPages.safety * this.pageSize;
      this.displayedSafetyL = this.safetyL.slice(0, endIndex);
    },
    
    // 滚动监听处理
    handleScroll(type) {
      const container = this.$refs[type + 'Container'];
      if (!container) return;
      
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      
      // 当滚动到底部附近时自动加载更多
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        if (type === 'news' && !this.loadingStates.news) {
          this.loadMoreNews();
        } else if (type === 'notice' && !this.loadingStates.notice) {
          this.loadMoreNotice();
        } else if (type === 'safety' && !this.loadingStates.safety) {
          this.loadMoreSafety();
        }
      }
    },
    
    jump(){
      this.$router.push({
        name:'HelloWorld',
      })
    },
    jumpS(){
      console.log(111)
      this.$router.push({
        name:'Survey',
        params:{
          num:1
        }
      });
    },
    jumpT(){
      this.$router.push({
        name:'State',
        params:{
          num:1
        }
      });
    },
    jumpF(){
      this.$router.push({
        name:'Party',
        params:{
          num:1
        }
      });
    },
    jumpFI(){
      this.$router.push({
        name:'Culture',
        params:{
          num:1
        }
      });
    },
    jumpSI(){
      this.$router.push({
        name:'Relation',
        params:{
          num:1
        }
      });
    },
    news(){
      this.isActive = 0;
      this.loadNewsData();
    },
    notice(){
      this.isActive = 1;
      this.loadNoticeData();
    },
    active(){
      this.isActive = 2;
      this.loadActiveData();
    },
    safety(){
      this.isActive = 3;
      this.loadSafetyData();
    }
  }
}
</script>

<style scoped>
a{
  color: #000;
  text-decoration: none;
  outline: medium none;
}

.l-container {
  width: 100%;
  min-height: 760px;
  margin: 0 auto;
  background: linear-gradient(rgba(12, 77, 162, 0.02), rgba(12, 77, 162, 0.05));
  padding: 40px 0;
}

.inner {
  padding: 0;
  width: 1300px;
  margin: 0 auto;
  display: flex;
  gap: 60px;
}

.col_menu {
  width: 280px;
  flex-shrink: 0;
}

.col_menu_head {
  background: linear-gradient(to right, #0a3d82, #1e5dbd);
  border-radius: 8px 8px 0 0;
  box-shadow: 0 5px 15px rgba(12, 77, 162, 0.2);
}

.col_menu_text {
  font-size: 24px;
  color: #fff;
  display: block;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  letter-spacing: 2px;
}

.col_list {
  background: white;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 5px 15px rgba(12, 77, 162, 0.1);
}

.wp_listcolumn {
  padding: 20px 0;
  margin: 0;
  list-style: none;
}

.wp_listcolumn li {
  margin: 0;
  padding: 0 20px;
}

.wp_listcolumn li a {
  padding: 15px 20px;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid rgba(12, 77, 162, 0.1);
  display: block;
  transition: all 0.3s ease;
  border-radius: 4px;
}

.wp_listcolumn li a:hover {
  background: rgba(12, 77, 162, 0.05);
  color: #0c4da2;
  transform: translateX(5px);
}

.wp_listcolumn li.select a {
  color: #0c4da2;
  background: rgba(12, 77, 162, 0.1);
  font-weight: bold;
}

.col_news {
  flex: 1;
  min-height: 500px;
}

.col_news_box {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.col_news_head {
  border-bottom: 1px solid rgba(12, 77, 162, 0.2);
  margin-bottom: 30px;
  padding-bottom: 15px;
}

.col_metas {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.col_path {
  color: #666;
  font-size: 14px;
}

.col_path span span {
  color: #0c4da2;
}

.col_title h2 {
  margin: 0;
  color: #0c4da2;
  font-size: 24px;
  font-weight: bold;
}

.col_news_con {
  padding: 20px 0;
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(12, 77, 162, 0.3) transparent;
}

.col_news_con::-webkit-scrollbar {
  width: 6px;
}

.col_news_con::-webkit-scrollbar-track {
  background: rgba(12, 77, 162, 0.1);
  border-radius: 3px;
}

.col_news_con::-webkit-scrollbar-thumb {
  background: rgba(12, 77, 162, 0.3);
  border-radius: 3px;
}

.col_news_con::-webkit-scrollbar-thumb:hover {
  background: rgba(12, 77, 162, 0.5);
}

.contain ul, .col_news_list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contain ul li, .col_news_list ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid rgba(12, 77, 162, 0.1);
  opacity: 0;
  animation: fadeInUp 0.5s ease forwards;
}

.contain ul li:nth-child(1) { animation-delay: 0.1s; }
.contain ul li:nth-child(2) { animation-delay: 0.2s; }
.contain ul li:nth-child(3) { animation-delay: 0.3s; }
.contain ul li:nth-child(4) { animation-delay: 0.4s; }
.contain ul li:nth-child(5) { animation-delay: 0.5s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.contain ul li a, .col_news_list ul li a {
  flex: 1;
  color: #333;
  font-size: 16px;
  transition: all 0.3s ease;
  padding-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contain ul li a:hover, .col_news_list ul li a:hover {
  color: #0c4da2;
  transform: translateX(5px);
}

.contain ul li span, .col_news_list ul li span {
  color: #999;
  font-size: 14px;
  flex-shrink: 0;
}

/* 懒加载相关样式 */
.load-more-container {
  text-align: center;
  padding: 20px 0;
  margin-top: 20px;
}

.load-more-btn {
  background: linear-gradient(to right, #0a3d82, #1e5dbd);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 3px 10px rgba(12, 77, 162, 0.3);
}

.load-more-btn:hover {
  background: linear-gradient(to right, #1e5dbd, #0a3d82);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(12, 77, 162, 0.4);
}

.load-more-btn:active {
  transform: translateY(0);
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #0c4da2;
  font-size: 14px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(12, 77, 162, 0.2);
  border-left: 2px solid #0c4da2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 750px) {
  .inner {
    width: 95%;
    flex-direction: column;
    gap: 20px;
  }

  .col_menu {
    width: 100%;
  }

  .wp_listcolumn {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
  }

  .wp_listcolumn li {
    width: 50%;
    padding: 5px;
  }

  .wp_listcolumn li a {
    padding: 10px;
    text-align: center;
  }

  .col_news_box {
    padding: 15px;
  }

  .col_metas {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .contain ul li, .col_news_list ul li {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .contain ul li span, .col_news_list ul li span {
    font-size: 12px;
  }
  
  .col_news_con {
    max-height: 400px;
  }
  
  .load-more-btn {
    padding: 10px 20px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/State.vue